(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function() {
  const accordionContainer = document.getElementById('FaqAccordion-{{ section.id }}');
  if (!accordionContainer) {
    return;
  }

  const faqItems = accordionContainer.querySelectorAll('.faq-item');

  const closeAllItems = () => {
    faqItems.forEach(item => {
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.icon');
      answer.classList.remove('active');
      icon.classList.remove('rotated');
      answer.style.maxHeight = null;
    });
  };

  faqItems.forEach((item, index) => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    const icon = item.querySelector('.icon');

    // Open the first item by default
    if (index === 0) {
      answer.classList.add('active');
      icon.classList.add('rotated');
      // Use setTimeout to ensure the element is rendered before getting its scrollHeight
      setTimeout(() => {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }, 0);
    }

    question.addEventListener('click', () => {
      const wasActive = answer.classList.contains('active');
      
      closeAllItems();

      if (!wasActive) {
        answer.classList.add('active');
        icon.classList.add('rotated');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // Re-calculate max-height on window resize to handle text wrapping changes
  window.addEventListener('resize', () => {
    const activeAnswer = accordionContainer.querySelector('.faq-answer.active');
    if (activeAnswer) {
      activeAnswer.style.maxHeight = activeAnswer.scrollHeight + 'px';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
